var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    height: "100%",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st1{fill:#ACACAC;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M500,127.3c-207.1,0-375,167.9-375,375c0,187.2,137.1,342.3,316.4,370.4v-262h-95.2V502.3h95.2v-82.6  c0-94,56-145.9,141.6-145.9c41,0,83.9,7.3,83.9,7.3v92.3h-47.3c-46.6,0-61.1,28.9-61.1,58.6v70.3h104L646,610.7h-87.4v262  C737.9,844.6,875,689.5,875,502.3C875,295.2,707.1,127.3,500,127.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3bdb63affc8c4d4e722b4321797ccbab.svg";
export { ForwardRef as ReactComponent };